import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MessagesGeneral, MessagesStatus, MessagesTitles } from 'app/models/messages';
import { LoginService } from 'app/services/login/login.service';
import { ListadoEmpresaClienteComponent } from './listado-empresa-cliente/listado-empresa-cliente.component';

@Component({
  selector: 'app-rep-marketing',
  templateUrl: './rep-marketing.component.html',
  styleUrls: ['./rep-marketing.component.scss'],
  providers:[MessagesTitles, MessagesGeneral, MessagesStatus,
    DatePipe,ListadoEmpresaClienteComponent]
})
export class RepMarketingComponent{

  constructor(private loginService: LoginService,
  private carga:ListadoEmpresaClienteComponent) { }


  clickGuard() {
    this.loginService.clickGuard = true;
  }
  ExportTOExcel() {
   this.carga.ExportTOExcel()
  }
}
